export const CONFIG = {
    MAX_QUESTIONS_PER_QB: 200,
    TABLE_PAGE_SIZE: 25,
};
